import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  FormControl,
  FormLabel,
  VStack,
  Text,
  Input,
  Progress,
  Button,
  useToast,
} from "@chakra-ui/react";
import { validateBulkFiles } from "../utils/fileValidation";

const BulkUploadModal = ({ isOpen, onClose, onUpload, isLoading }) => {
  const toast = useToast();
  const [files, setFiles] = useState([]);
  const [sourceReference, setSourceReference] = useState("");
  const [tags, setTags] = useState("");

  const handleSubmit = async () => {
    const validation = validateBulkFiles(files);
    if (!validation.valid) {
      toast({ title: validation.message, status: "warning", duration: 2500 });
      return;
    }

    const formData = new FormData();
    files.forEach((file) => formData.append("resumes", file));
    if (sourceReference.trim()) {
      formData.append("sourceReference", sourceReference.trim());
    }
    if (tags.trim()) {
      formData.append("tags", tags.trim());
    }

    await onUpload?.(formData);
    setFiles([]);
    setSourceReference("");
    setTags("");
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Bulk Upload Resumes</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack align="stretch" spacing={4}>
            <FormControl>
              <FormLabel>Resume Files</FormLabel>
              <Input
                type="file"
                multiple
                onChange={(e) => setFiles(Array.from(e.target.files || []))}
              />
            </FormControl>
            <Text fontSize="sm" color="gray.600">
              {files.length
                ? `${files.length} files selected`
                : "No files selected"}
            </Text>
            <FormControl>
              <FormLabel>Source Reference (Optional)</FormLabel>
              <Input
                value={sourceReference}
                onChange={(e) => setSourceReference(e.target.value)}
                placeholder="Bulk source reference"
              />
            </FormControl>
            <FormControl>
              <FormLabel>Tags (Optional)</FormLabel>
              <Input
                value={tags}
                onChange={(e) => setTags(e.target.value)}
                placeholder="comma,separated,tags"
              />
            </FormControl>
            {isLoading ? <Progress size="sm" isIndeterminate /> : null}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button mr={3} variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            onClick={handleSubmit}
            isLoading={isLoading}
          >
            Upload All
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default BulkUploadModal;
